import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-677febec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "overlay" }

import {ref, watch} from "vue";

// ------------------------------
//  Base
// ------------------------------


export default /*#__PURE__*/_defineComponent({
  name: 'FrameOverlay',
  props: {
  overriddenOverlayWidth: Number,
  overriddenOverlayHeight: Number,
},
  setup(__props) {

const props = __props

_useCssVars(_ctx => ({
  "6400b152": (overlayWidth.value),
  "4fb36c94": (overlayHeight.value)
}))



// ------------------------------
//  Overlay's target resize handling
// ------------------------------

const overlayWidth = ref("100%");
const overlayHeight = ref("100%");

const updateOverlayDimensions = () =>
{
  if (props.overriddenOverlayWidth && props.overriddenOverlayHeight)
  {
    overlayWidth.value = props.overriddenOverlayWidth + "px";
    overlayHeight.value = props.overriddenOverlayHeight + "px";
  }
};

watch(() => props.overriddenOverlayWidth, updateOverlayDimensions);
watch(() => props.overriddenOverlayHeight, updateOverlayDimensions);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})